import React from "react";

export default function Photos({ photos }) {
  return (
    <div className="photos">
      {photos.map((photo, index) => (
        <img key={index} src={photo.src.medium} alt="" />
      ))}
    </div>
  );
}